import { defineMessages } from '../helpers/intl/defineMessages';

export const messages = defineMessages('utils.zodSchemes', {
    requiredField: 'Field is required',
    invalidUrl: 'Please enter a valid URL',
});
